import {createFileRoute} from '@tanstack/react-router';

import PatientCreate from '@/practitioner/views/patient/PatientCreate';

export const Route = createFileRoute('/(practitioner)/patients/create')({
  component: PatientCreate
});
